"use strict";module.exports=require("../../../lib/address-queries");